// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    align-items: flex-start;
    align-self: stretch;
    border: 0px none;
    border-color: var(--theme-neutral-outlined-border) !important;
    display: flex;
    flex: 0 0 auto;
    position: relative;
    width: 100%;
}

.tab {
    align-items: center;
    font-family: Open Sans-SemiBold variable, Helvetica;
    background-color: var(--theme-primary-outlined-hoverbg);
    border: 1px solid;
    border-color: var(--brand-14bis-blue-medium);
    border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);
    display: inline-flex;
    flex: 0 0 auto;
    gap: 8px;
    padding: 8px 20px;
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicTabs/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;IAC7D,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mDAAmD;IACnD,uDAAuD;IACvD,iBAAiB;IACjB,4CAA4C;IAC5C,wFAAwF;IACxF,oBAAoB;IACpB,cAAc;IACd,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".tabs {\n    align-items: flex-start;\n    align-self: stretch;\n    border: 0px none;\n    border-color: var(--theme-neutral-outlined-border) !important;\n    display: flex;\n    flex: 0 0 auto;\n    position: relative;\n    width: 100%;\n}\n\n.tab {\n    align-items: center;\n    font-family: Open Sans-SemiBold variable, Helvetica;\n    background-color: var(--theme-primary-outlined-hoverbg);\n    border: 1px solid;\n    border-color: var(--brand-14bis-blue-medium);\n    border-radius: 6px 6px var(--border-radius-radius-none) var(--border-radius-radius-none);\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 8px;\n    padding: 8px 20px;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
